import React from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tailwind.css'
import './styles/globals.css'
import './styles/animations.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as gtag from 'ga-gtag'

if (import.meta.env.VITE_GOOGLE_TRACKING_ID) {
  gtag.install(import.meta.env.VITE_GOOGLE_TRACKING_ID)
}

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
